
import { defineComponent, computed, PropType, reactive, onMounted } from 'vue'
import { store } from '@/store'
import { getOldRoute, OldRoute, OldWaypoint } from '@/services/migration.service'
import router from '@/router'
import { CoordinatesModel, LocationModel, PlaceModel } from '@/api/tripply/models'
import { sortArray } from '@/api/tools'
import { db } from '@/api/firebase'
import { GA } from '@/api/analytics'

export default defineComponent({
  name: 'Migration',
  setup(props) {
    const state = reactive({
      modal: true,
      loading: true,
      success: false,
      error: '',
      errorReason: '',
      route: {} as OldRoute
    })

    onMounted(() => {
      setTimeout(async () => {
        const oldRouteId = router.currentRoute.value.params.id as string
        const oldUserId = router.currentRoute.value.params.uid as string
        const route = await getOldRoute(oldRouteId)
        state.route = route
        try {
          if (route.creator.uid !== oldUserId) {
            state.errorReason = 'permission'
            throw 'Du har ikke rettigheder til at flytte denne rute.'
          }
          state.errorReason = 'limit'
          const routeId = store.route.createRoute({
            name: route.name,
            custom: route.settings.method == 'custom',
            breakTime: parseInt(route.settings.breakTime) * 60,
            startTime: route.settings.startTime,
            startDate: '',
            timeLimit: 0,
            type: 'AB',
            vehicle: route.settings.vehicle,
            private: false,
            method: route.settings.method == 'custom' ? 'custom' : 'fastest',
            detailed: false
          }, true)
          if (routeId) {
            const waypoints = sortArray<OldWaypoint>(Object.values(route.waypoints), 'index')
            const locations = waypoints.map(wp => new LocationModel(wp.address, new CoordinatesModel(wp.lat,wp.lon), '', wp.name))
            const places = Object.values(locations).map(location => new PlaceModel(location))
            const excessPlaces = places.length - (store.user.permission('LIMIT_ROUTE_PLACES') as number)
            if (excessPlaces > 0) {
              store.global.toast({
                title: excessPlaces + ' stop på ruten blev udeladt.',
                msg: 'Ruten du forsøger at flytte har for mange stop. Opgradér til Tripply Plus for at flytte hele ruten.',
                type: 'warning',
                time: 10000
              })
            }
            await store.route.addPlaces(routeId, places.slice(0, store.user.permission('LIMIT_ROUTE_PLACES') as number))
            store.route.mutate(state => state.routes[routeId].migrationId = oldRouteId)
            GA('migration', { status: 'success' })
            await store.route.saveRoute(routeId)
            state.success = true
            state.loading = false
            setTimeout(() => {
                router.push('/routes')
            }, 3000)
          }
        } catch(err) {
          state.loading = false
          state.error = err
          GA('migration', { status: 'error', error: err })
        }
      }, 1000)
    })
    
    return { store, state }
  }
})
